<template>
  <div style="padding: 10px">
    <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
      <p slot="header" style="text-align:center">
        <Icon type="md-create" />
        <span>显示项设置</span>
      </p>
        <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
        </tr> -->
        <Form label-position="left" :label-width="100" style="margin-left:20px">
          <FormItem label="展示数据">
            <Tag :checked="showColumnTitleArray.indexOf(item.title) > -1" v-for="item in columnsbackup" :name="item.title" @on-change="changeColumn" size="medium" checkable color="primary">{{item.title}}</Tag>
          </FormItem>
        </Form>
      <div slot="footer">
        <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
      </div>
    </Modal>
    <Modal v-model="isShowStateModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="md-create" />
        <span>详细状态</span>
      </p>
      <table>
        <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
        </tr>
      </table>
      <div slot="footer"></div>
    </Modal>
    <div style="background: #fff; border-radius: 8px; ">
      <div class="query-c">
        <Row style="white-space:nowrap;">
            <Col span="8" style="padding:2px;margin:2px;border-radius: 25px;">
            <div style="margin-left:2%;">
              <br/>
              <div>
                <Select clearable filterable v-model="searchObject.userAccount" style="width:48%;margin-right: 5px" placeholder="选择客户名称">
                    <Option @click.native="onChangeUser(item.userMeterType)" v-for="item in userList" :value="item.userAccount" :key="item.userAccount">{{item.userName}}</Option>
                </Select>
                <Select clearable v-model="searchObject.meterType" style="width:48%;margin-right: 5px" placeholder="选择表具类型">
                    <!-- <Option value="水表" key="水表">水表</Option> -->
                    <Option v-for="item in meterTypeEnum" :value="item" :key="item">{{item}}</Option>
                </Select>
              </div>
              <div style="margin-top:5px">
                <Select clearable filterable placeholder="选择表具口径" v-model="searchObject.meterCaliber" style="width:48%">
                  <Option v-for="item in caliberEnum" :value="item" :key="item">{{ item }}</Option>
                </Select>
                <Input v-model="searchObject.meterAddress" placeholder="请输入表具地址" style="width: 48%;margin-left: 5px" />
              </div>
              
              <br/>
            </div>
            </Col>
            <Col span="9" style="padding:2px;margin:2px;border-radius: 25px;">
              <br/>
              <div style="margin-left:2%;">
                <!-- <Select v-model="selectMeterType" style="width:100px;margin-left: 20px;margin-right: 20px;">
                  <Option v-for="item in meterTList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select> -->
                <Select @on-change="onChangeSearchType" v-model="searchType" style="width:48%;">
                  <Option v-for="item in searchTypeTList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                <Select clearable v-model="warnType" placeholder="故障类型" style="width:48%;margin-left: 5px;">
                  <Option v-for="(value, key) in stateContrast" :value="key" :key="key">{{ key + " " +  value.replace("空管","报警")}}</Option>
                </Select>
              </div>  
              <div style="margin-left:2%;margin-top:5px">
                <!-- <DatePicker v-model="startDate"  type="datetime" placeholder="起始日期" style="width: 200px"></DatePicker>
                <DatePicker v-model="endDate"  type="datetime" placeholder="结束日期" style="width: 200px"></DatePicker> -->
                <DatePicker :disabled="cantSearch" format="yyyy-MM-dd" v-model="modalData.timeRange[0]" type="datetime" split-panels placeholder="选择时间"
                  style="width: 48%"></DatePicker>
                <!-- <Select :disabled="cantSearch" v-model="modalData.hourRange[0]" style="width:20%">
                  <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
                </Select> -->
                <DatePicker :disabled="cantSearch" format="yyyy-MM-dd" v-model="modalData.timeRange[1]" type="datetime" split-panels placeholder="选择时间"
                  style="width: 48%;margin-left: 5px;"></DatePicker>
                <!-- <Select :disabled="cantSearch" v-model="modalData.hourRange[1]" style="width:20%">
                  <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
                </Select> -->
                
                <!-- <Select filterable placeholder="请选择设备地址" v-model="meterAddress" style="width:150px;">
                  <Option v-for="item in meterArray" :value="item" :key="item">{{ item }}</Option>
                </Select> -->
              </div>
              <br/>
            </Col>
            <Col span="5" style="margin-left:35px">
              <br/>
              <Button type="primary" icon="ios-search" @click="showPage" :loading="okLoading" style="margin-left: 20px;margin-top:5px;width:40%">查询</Button>
              <Button type="primary" @click="isShowSetModal = true" style="margin-left: 20px;margin-top:5px;width:40%;float:right">显示项设置</Button>
                
              <div>
                <Button style="margin-left: 20px;margin-top:5px;width:40%;float:left" type="primary" @click="delAlarm">删除报警</Button>
              </div>
            </Col>
          </Row>
      </div>
      <Table @on-selection-change="selectRow" size="small" :height="tableHeight" border stripe :columns="columns" :data="data" highlight-row></Table>
      <!-- <Page :total="100" show-sizer show-elevator /> -->
        <div v-if="!isNaN(normal) && normal != ''" style="height:25%;">
          <Divider>故障报警统计</Divider>
          <Row>
            <span style="margin-right: 10px; font-weight:900">
              <Icon type="md-checkmark-circle" style="color:#19be6b;" size="30" /> 表具总数量： {{normal}}
            </span>
            <span style="margin-right: 10px; font-weight:900">
             <Icon type="md-close-circle" style="color:#ed4014;" size="30" /> 故障表具总数量： {{abnormal}}
            </span>
          </Row>
          <br/>
          <Row>
            <span v-for="(value, key) in warnCount"  style="margin-right: 10px; font-weight:900">
             <span v-if="value != 0" ><Icon type="ios-disc" style="color:#ed4014;" size="20" /> {{key.replace('":"'," ").replace("空管 空管","空管 报警") + ":  " + value}}</span>
            </span>
          </Row>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  export default {
    name: "faultalarm",
    data() {
      return {
        cantSearch: true,
        pageName: "faultalarm",
        meterTypeEnum: global.meterType(),
        searchType: 0,
        okLoading: false,
        hourList: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17',
          '18', '19', '20', '21', '22', '23','24'
        ],
        modalData: {
          timeRange: ['2020-01-15', '2020-01-15'],
          hourRange: ['0', '24'],
          timeSelect: 'hour'
        },
        searchTypeTList: [{
            value: 0,
            label: '最新报警'
          },
          {
            value: 1,
            label: '历史报警'
          }
        ],
        meterTList: [{
            value: 0,
            label: '水表'
          }
          // ,
          // {
          //   value: 1,
          //   label: '热表'
          // },
          // {
          //   value: 2,
          //   label: '流量表'
          // }
        ],
        showColumnTitleArray: [],
        columnsbackup: [
            {
                title: '选择',
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {
                title: "序号",
                type: 'index',
                width: 100,
                align: 'center'
            },
            {
              title: '表具类型',
              key: 'meterType',
              resizable: true,
              width: 160
            },
            {
              title: '表具地址',
              key: 'messageAddress',
              resizable: true,
              width: 160
            },
            {
              title: '口径',
              key: 'meterCaliber',
              resizable: true,
              width: 100
            },
            {
              title: "报警时间",
              width: 180,
              render: (h, params) => {
                return h("div", [
                  h(
                    "span", {
                      props: {},
                      style: {},
                      on: {}
                    },
                    global.dateFtt(
                      "yyyy-MM-dd hh:mm:ss",
                      new Date(params.row.messageTimestamp)
                    )
                  )
                ]);
              }
            },
            {
              title: '报警内容',
              resizable: true,
              width: 500,
              render: (h, params) => {
                return h("div", [
                  h(
                    "span", {
                      props: {},
                      style: {},
                      on: {}
                    },
                    this.showStateStr(params.row)
                  )
                ]);
              }
            }
          ],
        selectMeterType: 0,
        tableHeight: '200',
        addressfield1: "",
        addressfield2: "",
        addressfield3: "",
        addressfield4: "",
        addressfield5: "",
        meterReadingSum: 0.0,
        userList: [],
        warnCount: {},
        abnormal: 0,
        normal: "",
        warnType: "",
        searchObject: {},
        // meterArray: ["00000018003155", "00000018004345", "00000018004361", "00000018004457", "00000018004523",
        //   "00000018004635", "00000018004782", "00000018004789", "00000018004798", "00000018004799", "00000018004850",
        //   "00000018005048", "00000018005051", "00000018005064", "00000018005332", "00000018005388", "00000018005401",
        //   "00000018005405", "00000018005456", "00000018005462"
        // ],
        meterArray: [],
        meterArray1: ["00000018003155", "00000018004361", "00000018004457", "00000018004523",
          "00000018004798",  "00000018005064", "00000018005332", "00000018005401",
          "00000018005456", "00000018005462", "11110000000000"
        ],
        meterArray2:["00000018005405","00000018004345","00000018004799"],
        addressObject: {},
        stateContrast: global.stateContrast,
        meterAddress: "",
        stateArray: {},
        isShowStateModal: false,
        isShowSetModal: false,
        selectedRow: [],
        columns: [
            {
                title: '选择',
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {
                title: "序号",
                type: 'index',
                width: 100,
                align: 'center'
            },
            {
              title: '表具类型',
              key: 'meterType',
              resizable: true,
              width: 160
            },
            {
              title: '表具地址',
              key: 'messageAddress',
              resizable: true,
              width: 160
            },
            {
              title: '口径',
              key: 'meterCaliber',
              resizable: true,
              width: 100
            },
            {
              title: "报警时间",
              width: 180,
              render: (h, params) => {
                return h("div", [
                  h(
                    "span", {
                      props: {},
                      style: {},
                      on: {}
                    },
                    global.dateFtt(
                      "yyyy-MM-dd hh:mm:ss",
                      new Date(params.row.messageTimestamp)
                    )
                  )
                ]);
              }
            },
            {
              title: '报警内容',
              resizable: true,
              width: 500,
              render: (h, params) => {
                return h("div", [
                  h(
                    "span", {
                      props: {},
                      style: {},
                      on: {}
                    },
                    this.showStateStr(params.row)
                  )
                ]);
              }
            }
          ],
        data: [],
        caliberEnum: []
      };
    },
    methods: {
      onChangeSearchType(){
        console.log(this.searchType);
        if(this.searchType == 0){
          this.cantSearch = true;
        }else{
          this.cantSearch = false;
        }
      },
      onChangeUser(type){
        this.meterTypeEnum = global.getRealMeterType(type);
        if(this.meterTypeEnum.length > 0){
            this.searchObject.meterType = this.meterTypeEnum[0];
        }
        // console.log(type);
      },
      getMeterCaliberEnum(){
        var that = this;
        that.$axios.post('/api/meter/getMeterCaliberEnum', {}).then((data) => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          
          that.caliberEnum = data.body;
          that.caliberEnum.sort(function(a,b){
            return parseInt(a.replace("DN", "")) - parseInt(b.replace("DN", ""));
          });
        }).catch((error) => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        }).finally(() => {
          // that.showPage();
        });
      },
      delAlarm(){
        var that = this;
        if(that.selectedRow.length == 0){
          this.$Modal.info({
              title: "提示",
              content: "选择至少一条数据"
          });

          return;
        }
        that.$axios.post('/api/meterdetailed/delMeterAlarm', that.selectedRow).then(function(data) {
            console.log(data);
            if (data.errorCode != 0) {
                that.$Notice.error({
                    title: "异常",
                    desc: data.errorInfo
                });
                return;
            }

            that.$Notice.success({
                title: "提示",
                desc: "删除成功"
            });
          })
          .catch(function(error) {
            console.log(error);
          }).finally(() => {
              that.showPage();
              that.selectedRow = [];
          });
      },
      selectRow(selection, row){
        this.selectedRow = selection;
      },
      getUserList() {
        var that = this;
        that.$axios.post('/api/user/getUserList', {}).then(function(res) {
            console.log(res);
            that.userList = res.body;
          })
          .catch(function(error) {
            console.log(error);
          });
      },
      generateColumnTitleArray(){
        let titleArray = [];

        for(let i = 0; i < this.columnsbackup.length; i ++){
          titleArray.push(this.columnsbackup[i].title);
        }

        this.showColumnTitleArray = titleArray;

        if(localStorage.getItem(this.pageName + localStorage.getItem('userAccount')) != undefined){
          this.showColumnTitleArray  = JSON.parse(localStorage.getItem(this.pageName + localStorage.getItem('userAccount')));
          var showArray = [];
          for(let i = 0; i < this.columnsbackup.length; i ++){
            let currentObject = this.columnsbackup[i];
            if(this.showColumnTitleArray.indexOf(currentObject.title) > -1){
              showArray.push(currentObject);
            }
          }

          this.columns = showArray;
        }
      },
      getAddressEnum(){
        var that = this;
        that.$axios.post('/api/dictionary/selectAddressEnum', {
        }).then((data) => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          
          that.addressObject = data.body;
        }).catch((error) => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        }).finally(() => {
        });
      },
      parseDate(str) {
        var year = str.substr(0, 4);
        var month = str.substr(4, 2);
        var day = str.substr(6, 2);
        var hour = str.substr(8, 2);
        var minute = str.substr(10, 2);
        var second = str.substr(12, 2);
        return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
      },
      onClickSearch() {
        this.showPage();
      },
      showState(row) {
        this.isShowStateModal = true;
        this.stateArray = JSON.parse(row.messageContent).decode.state;
      },
      showStateStr(row) {
        let stateArray = JSON.parse(row.messageContent).decode.state;
        let that = this;
        let stateStr = "";
        Object.keys(stateArray).forEach(function(key) {
          if (stateArray[key] == that.stateContrast[key]) {
            stateStr = stateStr + key + " " + that.stateContrast[key] + "; ";
          }
        });

        return stateStr == "" ? "正常" : stateStr.replace("空管 空管", "空管");
      },
      changeColumn(checked, name){
        if(checked){
          this.showColumnTitleArray.push(name);
        }else{
          this.showColumnTitleArray.splice(this.showColumnTitleArray.indexOf(name), 1);
        }

        var showArray = [];

        for(let i = 0; i < this.columnsbackup.length; i ++){
          let currentObject = this.columnsbackup[i];
          if(this.showColumnTitleArray.indexOf(currentObject.title) > -1){
            showArray.push(currentObject);
          }
        }

        localStorage.setItem(this.pageName + localStorage.getItem('userAccount'), JSON.stringify(this.showColumnTitleArray));

        this.columns = showArray;
      },
      getCurrentMeterType(){
        let meterType = "";

        for(let i = 0; i < this.meterTList.length; i ++){
            let temp = this.meterTList[i];

            if(temp.value == this.selectMeterType){
                meterType = temp.label;
                break;
            }
        }

        return meterType;
      },
      showPage() {
        var that = this;
        if(that.searchObject.userAccount == undefined || that.searchObject.userAccount == ""){
            that.$Modal.info({
                title: "提示",
                content: "请先选择客户！"
            });
            return;
        }
        if (this.modalData.timeRange[0] && this.modalData.timeRange[1] && this.modalData.hourRange[0] && this.modalData
          .hourRange[1]) {
          let dateStart = new Date(this.modalData.timeRange[0]);
          dateStart.setHours(this.modalData.hourRange[0] * 1);
          let dateEnd = new Date(this.modalData.timeRange[1]);
          dateEnd.setHours(this.modalData.hourRange[1] * 1);

          that.searchObject.startDate = dateStart;
          that.searchObject.endDate = dateEnd
        }
        
        that.data = [];
        that.$axios.post('/api/meterdetailed/selectMeterAlarm', {
            startDate: that.searchObject.startDate,
            endDate: that.searchObject.endDate,
            selectMeterType: that.selectMeterType,
            searchType: that.searchType,
            meterAddress: that.searchObject.meterAddress,
            warnType: that.warnType == ""?"":that.warnType + '":"' + that.stateContrast[that.warnType],
            meterType: that.searchObject.meterType,
            userAccount: that.searchObject.userAccount,
            meterCaliber: that.searchObject.meterCaliber
        }).then(function(res) {
            console.log(res);
            var array = res.body.array;
            var resultArray = [];
            var abMeterArray = [];
            var successSum = 0.0;

            for(let i = 0; i < array.length; i ++){
                var temp = array[i];
                if(temp.messageContent != undefined){
                    resultArray.push(temp);
                }
            }

            let abnormal = 0;
            let countObject = {};
            let abInfoArray = [];
                Object.keys(that.stateContrast).forEach(function(key) {
                countObject[key + '":"' + that.stateContrast[key]] = 0;
                });
            for(let i = 0; i < array.length; i ++){
                let abn = false;
                let currentObject = array[i];
                Object.keys(that.stateContrast).forEach(function(key) {
                    if (new String(currentObject.messageContent).indexOf(key + '":"' + that.stateContrast[key]) > -1) {
                        countObject[key + '":"' + that.stateContrast[key]] =  countObject[key + '":"' + that.stateContrast[key]] + 1;
                        abn = true;
                    }
                });

                if(abn){
                    if(that.showStateStr(currentObject) != "正常"){
                        if(that.searchType == 1){
                          abInfoArray.push(currentObject);
                        }else if(abMeterArray.indexOf(currentObject.meterAddress) == -1 && that.searchType == 0){
                          abInfoArray.push(currentObject);
                          abMeterArray.push(currentObject.meterAddress);
                        }
                        
                        
                    }
                }
            }

            that.abnormal = abMeterArray.length;
            that.normal = that.meterArray.length - abnormal;
            that.warnCount = countObject;

            console.log(resultArray);
            that.data = abInfoArray;
          })
          .catch(function(error) {
            console.log(error);
          });
      },
      async getMeterArray(){
        var that = this;
        that.$axios.post('/api/meter/selectMeterList', {
          addressfield1: that.addressfield1,
          addressfield2: that.addressfield2,
          addressfield3: that.addressfield3,
          addressfield4: that.addressfield4,
          addressfield5: that.addressfield5
        }).then((data) => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          
          that.meterArray = data.body;

          that.showPage();
          console.log(data.body);
        }).catch((error) => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        }).finally(() => {
        });
      }
    },
    mounted() {
      // this.showPage();
      let that = this;
      window.addEventListener('resize', function() {
        that.tableHeight = (window.innerHeight - 186) * 0.6;
      })
      that.tableHeight = (window.innerHeight - 186) * 0.6;

      that.generateColumnTitleArray();
    //   that.getMeterArray();
      that.getAddressEnum();
      that.getUserList();
      that.getMeterCaliberEnum();
      that.modalData.timeRange[0] = global.dateFtt("yyyy-MM-dd", new Date());
      that.modalData.timeRange[1] = global.dateFtt("yyyy-MM-dd", new Date());
    }
  };
</script>

<style scoped>
</style>
